import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Franchisee from './index';
import MobileFranchisee from './MobileFranchisee';

const ResponsiveFranchisee = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileFranchisee />}
      desktop={<Franchisee />}
    />
  );
};

export default ResponsiveFranchisee;